// extracted by mini-css-extract-plugin
export default {"content":"index_content_rsXeq","clear":"index_clear_r1ni8","boxBot":"index_boxBot_4slzn"};